import { Injectable } from '@angular/core';
import { AssetSearchCriteria } from 'src/app/api/asset/search/assetSearchCriteria';
import { CustomerSearchQuery } from 'src/app/api/customer/customerSearchQuery';
import { SiteSearchQuery } from 'src/app/api/site/siteSearchQuery';

@Injectable({
  providedIn: 'root'
})
export class SearchStateService {
  private searchState: AssetSearchCriteria | SiteSearchQuery | CustomerSearchQuery | null = null;

  getAssetSearchState(): AssetSearchCriteria | null {
    if (this.searchState instanceof AssetSearchCriteria) {
      return this.searchState;
    }

    return null;
  }

  getCustomerSearchState(): CustomerSearchQuery | null {
    if (this.searchState instanceof CustomerSearchQuery) {
      return this.searchState;
    }

    return null;
  }

  getSiteSearchState(): SiteSearchQuery | null {
    if (this.searchState instanceof SiteSearchQuery) {
      return this.searchState;
    }
    
    return null;
  }

  saveSearchState(state: AssetSearchCriteria | SiteSearchQuery | CustomerSearchQuery): void {
    const stateCopy = { ...state, start: 0 };
    this.searchState = stateCopy;
  }
}
